import React, { useEffect } from "react";
import {
  Container,
  Grid,
  Box,
  Paper,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Skeleton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getDeveloper } from "../../features/Developers/developerSlice";

const Home = () => {
  const { developer, developers, pending } = useSelector(
    (state) => state.developers
  );
  const { attributes, home } = developer;

  const { dev } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDeveloper(`${dev}`));
  }, []);
  return (
    <>
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          height: "100vh",
          justifyContent: "start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "left",
          }}
        >
          <Grid
            container
            sx={
              {
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // // flexDirection: { xs: "column", sm: "row" },
              }
            }
            spacing={{ xs: "32", md: "16", lg: "32" }}
          >
            <Grid item xs={12} sm={8}>
              <Box>
                {home?.[0]?.home_welcome && !pending ? (
                  <Typography variant="h4">
                    {home?.[0]?.home_welcome}
                  </Typography>
                ) : (
                  <Skeleton
                    variant="text"
                    // sx={{ fontSize: "3rem" }}
                    width="40vw"
                  />
                )}{" "}
                {home?.[0]?.home_title && !pending ? (
                  <Typography variant="h6">{home?.[0]?.home_title}</Typography>
                ) : (
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "2rem" }}
                    // width="500vw"
                  />
                )}
                {home?.[0]?.home_description && !pending ? (
                  <Typography>{home?.[0]?.home_description}</Typography>
                ) : (
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "1rem" }}
                    // width="500vw"
                  />
                )}
                {!pending ? (
                  <Button size="large" sx={{ mt: 2 }} variant="outlined">
                    Contact Me
                  </Button>
                ) : (
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "1rem" }}
                    // width="500vw"
                    height={50}
                    width={150}
                  />
                )}
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              sx={{ display: { xs: "none", sm: "flex" } }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {attributes?.photoUrl && !pending ? (
                  <Box
                    component="img"
                    s
                    src={`${attributes?.photoUrl}`}
                    sx={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <Skeleton
                    // ml={5}
                    variant="circular"
                    width={150}
                    height={150}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default Home;
